import {gsap} from "gsap";
import Cookie from "@templates/App/Cookies.js";

const Notifications = {

    init() {
        this.el = $('[component="notifications"]');
        if (!this.el.length || this.el.is('[hidden]')) return;

        this.id = this.el.attr('id');
        this.popAgain = parseInt(this.el.attr('pop-again'));
        this.popAgainDelay = parseInt(this.el.attr('pop-again-delay'));

        // console.log(this.id, this.popAgain, this.popAgainDelay);

        if (Cookie.get('closedNotification_' + this.id)) return;

        this.closeBtn = this.el.find('button.close');
        this.goBtn = this.el.find('.button.next');
        this.bind();

        setTimeout(() => {
            this.show();
        }, 1000)
    },

    bind() {
        this.closeBtn.click((evt) => {
            this.close();
        })
        this.goBtn.click((evt) => {
            this.close();
        })
    },

    close() {
        let expires = new Date();

        switch (this.popAgain) {
            case 0:
                expires.setFullYear(expires.getFullYear() + 1);
                break;
            case 1:
                expires = null;
                break;
            case 2:
                expires.setTime(expires.getTime() + (this.popAgainDelay * 60 * 60 * 1000));
                break;
        }

        const cookieName = 'closedNotification_' + this.id;
        Cookie.set(cookieName, 1, expires);

        gsap.timeline()
            .to(this.el, {display: 'none', opacity: 0, duration: 1}, 0)
            .to(this.el.find('[container]'), {scale: 0.7, duration: 0.5, ease: "back.in"}, 0)
    },

    show() {
        if (!this.el.length) return;
        gsap.timeline()
            .to(this.el, {display: 'flex', opacity: 1, duration: 1}, 0)
            .from(this.el.find('[container]'), {scale: 0.7, duration: 0.5, ease: "back.out"}, 0)
    },

}

export default Notifications;